import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import LocationService, { LocationDetail } from "@/app/_services/LocationService";

export function useLocationDetailModel() {
  const { location_id } = useParams<{ location_id: string }>();
  const [data, setData] = useState<LocationDetail | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [openEditForm, setOpenEditForm] = useState(false);

  function loadLocationDetail() {
    if (!location_id) return;
    setIsLoading(true);
    LocationService.getLocationDetailAsync(location_id)
      .then(setData)
      .finally(() => setIsLoading(false));
  }

  useEffect(() => {
    loadLocationDetail();
  }, [location_id]);

  return {
    data,
    isLoading,
    openEditForm,
    openEdit: () => setOpenEditForm(true),
    closeEdit: () => setOpenEditForm(false),
    refetch: loadLocationDetail,
  };
}
